<template>
  <v-container fluid class="tiles">
    <v-chip v-for="(tile, index) in tiles" :key="category + tile.id + index" class="ma-1">
      <v-btn @click="addTile(tile)" text x-small class="pa-0">{{ tile.name }}</v-btn>
    </v-chip>

    <v-divider v-if="selectedTiles.length > 0" class="mt-5" />

    <v-row>
      <v-col class="ml-5">
        <v-chip
          v-for="(tile, index) in selectedTiles"
          :key="index"
          color="accent"
          class="mr-4"
          close
          @click:close="removeTile(index)"
        >{{tile.name}}</v-chip>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  props: ["category", "tiles", "existingTiles"],

  data() {
    return {
      selectedTiles: []
    };
  },

  methods: {
    addTile(tile) {
      let duplicate = this.selectedTiles.find(newTile => {
        return newTile.name === tile.name;
      });

      if (!duplicate) {
        this.selectedTiles.push(tile);
        this.$emit("add", this.selectedTiles);
      }
    },

    removeTile() {
      this.$emit("remove", this.selectedTiles);
    }
  },

  mounted() {
    this.selectedTiles = [];
    this.existingTiles.forEach(tile => {
      this.selectedTiles.push(tile);
    });
  }
};
</script>

<style lang="sass" scoped>
  .tiles
    background: $c-white
</style>
